module.exports = __webpack_public_path__ + "img/neg-x.ff61b930.png";